import * as attendedPresentationUtil from '@/utils/attendedPresentation.util'

const setSlides = (state, payload) => {
  state.slides = payload
}

const setSlideIndex = (state, payload) => {
  if (!state.presentation || !state.presentation.id || payload == -1) return
  state.slideIndex = payload
}

const setMaxLookbackSlideIndex = (state, payload) => {
  if ((state.presentation.audiencePacing || state.presentation.presenting) && payload > state.maxLookbackSlideIndex) {
    state.maxLookbackSlideIndex = payload
    attendedPresentationUtil.setValueByPresentationUniqueAccessCode(state.presentation.uniqueAccessCode, 'maxLookbackSlideIndex', payload)
  }
}

export default {
  setSlides,
  setSlideIndex,
  setMaxLookbackSlideIndex,
}
